import PropTypes from "prop-types";
import React from "react";
import CreateAccountForm from "../../sections/create-account-form";
import HeroAccount from "../../sections/hero-account";
import InfoPanel from "../../sections/info-panel";
import VerifyEmailForm from "../../sections/verify-email-form";
import { codeTypes } from "../../utils/lynkco-constants";
import useCreateAccount from "../../hooks/useCreateAccount";
import "./style.scss";

export default function CreateAccount({ isAccountPreview, collectInfoStep, valueToParent, verifyStep, onLogined = () => {} }) {
  const {
    newsletter: { id: newsletterConsentNo },
    termsAndConditions
  } = collectInfoStep.createAccountForm;
  const termsContents = termsAndConditions.map(x => x.id);
  const { formData, submitting, isNetworkFailed, accountExists, phoneExists, sendCodeFailed, createAccountFailed, isVerificationStep, registrationInProcess, verificationFailed, submitAccountInfo, onVerification } = useCreateAccount();
  const createAccountFormProps = {
    ...collectInfoStep.createAccountForm,
    createAccountFailed,
    sendCodeFailed,
    verificationFailed,
    isNetworkFailed,
    accountExists,
    phoneExists,
    registrationInProcess,
    submitting,
    newValueToParent: value => valueToParent(value),
    preFilledData: formData,
    submitCreateAccount: async (evt, data) => {
      await submitAccountInfo(evt, data);
    },
  };
  const verifyEmailFormProps = {
    ...verifyStep.verifyEmailForm,
    // ...verifyEmailForm.fields,
    sendCodeFailed,
    verificationFailed,
    createAccountFailed,
    isNetworkFailed,
    registrationInProcess,
    submittedEmail: formData?.email,
    codeType: codeTypes.activeAccount,
    async onVerificationCodeSubmitted(evt, data) {
      const { userInfo } = await onVerification(data, termsContents, newsletterConsentNo);
      if (userInfo) {
        /** Measurement */
        let dataLayer = window.dataLayer || [];
        let membershipLevel = "";

        switch (userInfo.membershipCode) {
          case "MEMBERSHIP01":
            membershipLevel = "Level0";
            break;
          case "MEMBERSHIP02":
            membershipLevel = "Level1";
            break;
          case "MEMBERSHIP03":
            membershipLevel = "Level2";
            break;
          case "MEMBERSHIP04":
            membershipLevel = "Level3";
            break;
        }
        dataLayer.push({
          event: "accountVerification",
          eventCategory: "account",
          eventAction: "verify",
          eventLabel: membershipLevel
        });
        onLogined && onLogined();
      }
    }
  };
  return (
    <div className="create-account">
      {!isVerificationStep && (
        <div className={!isAccountPreview ? "grid" : ""}>
          {!isAccountPreview && <HeroAccount {...collectInfoStep.hero} />}
          <CreateAccountForm {...createAccountFormProps}/>
          {!isAccountPreview && <InfoPanel {...collectInfoStep.info} />}
        </div>
      )}
      {isVerificationStep && (
        <div className={!isAccountPreview ? "grid" : ""}>
          {!isAccountPreview && <HeroAccount {...verifyStep.hero} />}
          <VerifyEmailForm {...verifyEmailFormProps} />
          {!isAccountPreview && <InfoPanel {...verifyStep.info} />}
        </div>
      )}
    </div>
  );
}

CreateAccount.propTypes = {
  collectInfoStep: PropTypes.object,
  verifyStep: PropTypes.object,
  onAccountCreate: PropTypes.func,
  onResendVerificationCode: PropTypes.func,
  onVerificationCodeSubmited: PropTypes.func,
  isInVerificationStep: PropTypes.bool,
  isAccountPreview: PropTypes.bool,
  newValueToParent: PropTypes.func
};

CreateAccount.defaultProps = {
  onAccountCreate: () => {},
  onResendVerificationCode: () => {},
  onVerificationCodeSubmited: () => {},
  isInVerificationStep: false,
  isAccountPreview: false
};
